import { useTranslation } from 'react-i18next'

export const LoadingScreen = ({ loading }: { loading: boolean }) => {
  const { t } = useTranslation()
  return (
    <div className="loading-screen">
      <img src="/logos/logo.svg" alt="embrace" />
      <div>
        <h2>{t('loading.screen.title')}</h2>
        <span>{t('loading.screen.description')}.</span>
        <div className="loader" />
      </div>
    </div>
  )
}
